import BetOptions from "slotworks/components/betbar/vo/bet-options";
import { GameConfigSchema } from "slotworks/config/game-config-schema";
import Currency from "slotworks/i18n/currency";
import SettingsModel from "slotworks/model/settings/settings-model";
import SlotDefinition from "slotworks/model/slot-definition";
import { Stepper } from "slotworks/integration/revolver/schema/init-record-schema";
class BetModel {

    private coinValue: number = 0.01;
    private betPerLine: number = 0;
    private selectedLines: number[] = [];
    private stepper: Map<number, Stepper> = new Map();

    public processConfig(gameConfig: GameConfigSchema) {
        this.setDefaults(gameConfig.defaultStake, gameConfig.defaultLines, gameConfig.defaultCoinSize);
    }

    public setDefaults(bet: number, lines: number[] | number, coinSize: number) {
        this.setCoinSize(coinSize);
        this.setBetPerLine(bet);
        this.setSelectedLines(lines);
    }

    public setBetPerLine(bet: number, save: boolean = false) {
        this.betPerLine = bet;
        if(save) {
            SettingsModel.flush();
        }
    }

    public isValidBetPerLine(bet: number):boolean {
        if(SlotDefinition.stakes.indexOf(bet) >= 0) 
            return true;
        return false;
    }

    public isValidCoinSize(value: number) {
        if(SlotDefinition.coinSizes.indexOf(value) >= 0)
            return true;
        return false;
    }

    public isValidSelectedLines(lines: number[] | number) {
        return true;
    }

    public getBetPerLine(): number {
        return this.betPerLine;
    }

    public setCoinSize(value: number, save: boolean = false) {
        this.coinValue = value;
        Currency.creditRatio = this.coinValue;
        
        if(save) {
            SettingsModel.flush();
        }
    }

    public getCoinSize(): number {
        return this.coinValue;
    }

    public setSelectedLines(lines: number[] | number, save: boolean = false) {
        if (lines instanceof Array) {
            this.selectedLines = lines.concat();
        } else {
            const newLines = [];

            for (let i = 1; i <= lines; i++) {
                newLines.push(i);
            }

            this.selectedLines = newLines;
        }

        if(save) {
            SettingsModel.flush();
        }
    }

    public getSelectedLineIds(): number[] {
        return this.selectedLines;
    }

    public getSelectedLines(): number {
        return this.selectedLines.length || 1;
    }

    public getTotalCoinBet(): number {
        return this.getBetPerLine() * this.getSelectedLines();
    }

    public getTotalBet(): number {
        return this.getTotalCoinBet() * this.getCoinSize();
    }

    public setStepper(stepper: Stepper[]) {
        if(stepper) {
            for(let step of stepper) {
                const key = SlotDefinition.coinSizes[step.coin_level - 1] * SlotDefinition.stakes[step.bet_level - 1] * this.getSelectedLines();
                this.stepper.set(key, step);
            }
        }
    }

    public generateBetOptions(): BetOptions {
        const betOptions = new BetOptions();

        betOptions.maxLines = SlotDefinition.lineDefinitions.length;
        betOptions.stakePerLineValues = SlotDefinition.stakes;
        betOptions.coinSizes = SlotDefinition.coinSizes;

        betOptions.lines = this.getSelectedLines();
        betOptions.stakePerLine = this.getBetPerLine();
        betOptions.coinSize = this.getCoinSize();

        betOptions.stepper = this.stepper;

        return betOptions;
    }
}

export default new BetModel();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/bets/bet-model.ts